import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import "./pd-rating-item.js";
import "../pd-rating-input.js";
import { LitElement, css, html, nothing } from "lit";
import { property, state } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import "@progressive-development/pd-forms/pd-button";
import { repeat } from "lit/directives/repeat.js";
//#region src/pd-rating/PdRatingList.ts
/**
* @license
* Copyright (c) 2026 PD Progressive Development UG. All rights reserved.
*/
var PdRatingList = class PdRatingList extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.entries = [];
		this.loading = false;
		this.withCreate = false;
		this._createOpen = false;
	}
	static {
		this.styles = css`
    :host {
      display: block;
      container-type: inline-size;
    }

    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;
      flex-wrap: wrap;
    }

    .head-slot {
      flex: 1;
      min-width: 0;
    }

    .create-form {
      padding: 0.6rem 0;
      border-bottom: 1px solid
        var(--pd-rating-separator-col, var(--pd-default-light-col, #e0e0e0));
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      padding: var(--pd-rating-row-gap, 0) 0;
    }

    li + li {
      border-top: 1px solid
        var(--pd-rating-separator-col, var(--pd-default-light-col, #e0e0e0));
    }

    .empty {
      color: var(--pd-default-font-muted-col, #757575);
      font-style: italic;
      padding: 0.6rem 0;
    }

    .skeleton {
      height: 3rem;
      margin: 0.6rem 0;
      border-radius: 4px;
      background: var(--pd-default-bg-light-col, #eee);
      animation: pulse 1.5s ease-in-out infinite;
    }

    @keyframes pulse {
      50% {
        opacity: 0.5;
      }
    }
  `;
	}
	render() {
		return html`
      <div class="head">
        <div class="head-slot"><slot name="head"></slot></div>
        ${this.withCreate && !this._createOpen ? html`
                <pd-button
                  size="sm"
                  .text="${msg("Bewertung schreiben", { id: "pd.rating.list.create" })}"
                  @click="${() => this._createOpen = true}"
                ></pd-button>
              ` : nothing}
      </div>
      ${this.withCreate && this._createOpen ? html`
              <div class="create-form">
                <pd-rating-input
                  @pd-rating-submit="${this._closeCreate}"
                  @pd-rating-cancel="${this._closeCreate}"
                ></pd-rating-input>
              </div>
            ` : nothing}
      ${this.loading ? this._renderLoading() : this._renderList()}
      <slot name="footer"></slot>
    `;
	}
	/**
	* Filter hook for a later search/filter extension —
	* the render list always runs through this step.
	*/
	get _visibleEntries() {
		return this.entries;
	}
	/** Submit/cancel close the form; both events bubble on to the app. */
	_closeCreate() {
		this._createOpen = false;
	}
	_renderLoading() {
		return html`
      <div
        role="status"
        aria-label="${msg("Bewertungen werden geladen", { id: "pd.rating.list.loading" })}"
      >
        <div class="skeleton"></div>
        <div class="skeleton"></div>
        <div class="skeleton"></div>
      </div>
    `;
	}
	_renderList() {
		const entries = this._visibleEntries;
		if (entries.length === 0) return html`
        <div class="empty">
          ${this.emptyText ?? msg("Noch keine Bewertungen", { id: "pd.rating.list.empty" })}
        </div>
      `;
		return html`
      <ul role="list">
        ${repeat(entries, (entry) => entry.id, (entry) => html`
            <li>
              <pd-rating-item .entry="${entry}"></pd-rating-item>
            </li>
          `)}
      </ul>
    `;
	}
};
__decorate([property({ attribute: false })], PdRatingList.prototype, "entries", void 0);
__decorate([property({ type: Boolean })], PdRatingList.prototype, "loading", void 0);
__decorate([property()], PdRatingList.prototype, "emptyText", void 0);
__decorate([property({ type: Boolean })], PdRatingList.prototype, "withCreate", void 0);
__decorate([state()], PdRatingList.prototype, "_createOpen", void 0);
PdRatingList = __decorate([localized()], PdRatingList);
//#endregion
export { PdRatingList };
